<div *ngIf="table" [class.add-border]="addBorder"
     class="input-group">
    <span class="input-group-addon"><img src="/assets/images/payhoa/other/search.svg"/></span>
    <input #searchField
           class="form-control"
           placeholder="Search..."
           type="text"/>
    <span (click)="clearSearch(); searchField.value = '';"
          *ngIf="config.filter !== ''"
          class="input-group-addon">
            <img src="/assets/images/app/icons/icon_close.svg"/>
    </span>
</div>
